import Container from "react-bootstrap/Container";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./LoadingContainerLarge.css";

export default function LoadingContainerLarge() {
  return (
    <Container>
      <Row>
        <SkeletonTheme baseColor="#f7f7f7" highlightColor="#eeeeee">
          <Skeleton count={1} className="loading-container-large-card" />
          <Skeleton count={1} className="loading-container-large-card" />
        </SkeletonTheme>
      </Row>
    </Container>
  );
}
